import { useQuery } from '@tanstack/react-query';

import { fetchGeoCoordinates } from './location.api';

export const useGeoCoordinates = ({ enabled }: { enabled: boolean }) =>
  useQuery({
    enabled,
    queryFn: () => fetchGeoCoordinates(),
    queryKey: ['geoCoordinates'],
    staleTime: Infinity,
  });
